module.exports = {
      id: "ic-empty-state-usage",
      viewBox: "0 0 96 96",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-empty-state-usage",
      toString: function () {
        return this.url;
      }
    }